const thousandsregex = new RegExp(/(.)(?=(\d{3})+$)/g);

export const formatThousands = (n) => {
    const val = `${n}`;
    return val.replace(thousandsregex, '$1 ');
};

export const graphXaxisFormatter =
    (n, a = -1) =>
    (val) =>
        ++a % n === 0 ? val : '';

const _isValidDate = (wannabeDate) => {
    if (Object.prototype.toString.call(wannabeDate) === '[object Date]') {
        if (isNaN && isNaN(wannabeDate.getTime())) {
            return false;
        }
    } else {
        return false;
    }

    // valid!
    return true;
};

const months = {
    0: 'jan',
    1: 'feb',
    2: 'mars',
    3: 'apr',
    4: 'mai',
    5: 'jun',
    6: 'jul',
    7: 'aug',
    8: 'sep',
    9: 'okt',
    10: 'nov',
    11: 'des',
};

export const toEmployerDate = (arg) => {
    if (!arg) {
        return '';
    }
    if (!_isValidDate(arg)) {
        return '';
    }

    return `${arg.getDate()}. ${months[arg.getMonth()]}`;
};
